module.exports = __webpack_public_path__ + "assets/fc85279c157a96d8fad8a449a077b3ff.png";